import { TextCodes } from '@api/types/translation/TextCodes';
import { SmartLink } from '@components';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box } from '@mui/material';
import { t } from '@translations';

type BackButtonProps = {
  href?: string;
  children?: React.ReactNode;
};

export const BackButton: React.FC<BackButtonProps> = ({ href, children }: BackButtonProps) => {
  return (
    <Box
      sx={{
        width: 'fit-content',
        '& .link-text': {
          display: 'flex',
          alignItems: 'center',
        },
        mb: 2,
      }}
    >
      <SmartLink href={href}>
        <ChevronLeftIcon />
        {children || t(TextCodes.Base.Back)}
      </SmartLink>
    </Box>
  );
};
